import { render, staticRenderFns } from "./RecipientListModal.vue?vue&type=template&id=689fcedd"
import script from "./RecipientListModal.vue?vue&type=script&lang=js"
export * from "./RecipientListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports